<template>
	<div id="history">
		<div class="times">
			<a href="javascript:;" v-for="(tm,idx) in times" :class="time==idx?'active':''" @click="time=idx">{{tm}}</a>
		</div>
		<div class="search-div ">
			<div>
				<label for="">{{$t('chargeHistory.QueryRange')}}</label>
				<span>{{times[time]}}</span>
			</div>
			<div>
				<label for="">{{$t('chargeHistory.Selectgames')}}</label>
				<select name="" v-model="game_id" id="">
					<option :value="game.id" v-for="(game,idx) in games" :key="'game-'+idx">{{game.name[$i18n.locale]}}</option>
				</select>
			</div>
			<div>
				<label for=""></label>
				<wd-button type="danger" size="small" :styles="{width:'160px',height:'40px'}" @click.native="getRecords(1)">{{$t('chargeHistory.Inquire')}}</wd-button>
			</div>
		</div>
		<table cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th><span>{{$t('chargeHistory.Time')}}</span></th>
					<th><span>{{$t('charge.OrderNumber')}}</span></th>
					<th><span>{{$t('chargeHistory.GameServer')}}</span></th>
					<th><span>{{$t('chargeHistory.Paymentmethod')}}</span></th>
					<th><span>{{$t('charge.Topup')}}</span></th>
					<th><span>{{$t('charge.RedeemCode')}}</span></th>
					<th><span>{{$t('chargeHistory.Status')}}</span></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="charge in charges" :key="'charge-'+charge.id">
					<td>{{charge.created_at}}</td>
					<td>{{charge.order_no}}</td>
					<td>{{getChargeGameRegion(charge.game_id,charge.region_id)}}</td>
					<td>{{charge.payment?charge.payment.name:'-'}}</td>
					<td>{{charge.currency+' '+charge.amount/100}}</td>
					<td>{{charge.charge_code?charge.charge_code:'-'}}</td>
					<td>{{payStatus[charge.status]}}</td>
				</tr>
			</tbody>
		</table>
		<div v-if="lastPage>1" style="text-align: center;">
			<pagenation :totalPage="lastPage" :page="page" @changePage="getRecords"></pagenation>
		</div>
	</div>
</template>
<script>
	import WdButton from '@/components/WdButton.vue';
	import Pagenation from '@/components/Pagenation.vue';
	export default{
		name:"chargeHistory",
		components:{
			'wd-button':WdButton,
			'pagenation':Pagenation
		},
		data(){
			return {
				time:'1',
				game_id:1,
				page:1,
				lastPage:0,
				games:[],
				payments:[],
				charges:[],
			}
		},
		computed: {
	       times(){
	       	return {
	       		'1':this.$t('chargeHistory.LastWeek'),
	       		'2':this.$t('chargeHistory.LastMonth'),
	       		'3':this.$t('chargeHistory.HistoricalRecharge')
	       	}
	       },
	       payStatus(){
	       	 return {
					'0':this.$t('charge.NewOrder'),
					'1':this.$t('charge.StyleDeal'),
					'2':this.$t('charge.Dealing'),
					'3':this.$t('charge.RechargeSuccessful'),
					'4':this.$t('charge.RechargeFailed'),
					'5':this.$t('charge.CancelTheRecharge'),
					'6':this.$t('charge.Refunded'),
					'7':this.$t('charge.CancelTheRefund'),
					'8':this.$t('charge.RefundFailed'),
					'9':this.$t('charge.Refunding'),
					'10':this.$t('charge.Expired'),
					'11':this.$t('charge.Unpaid'),
					'12':this.$t('charge.Checking'),
	       	 }
	       }
	    },
		methods:{
			getChargeGameRegion(game_id,region_id){
				let game_name = '';
				let region_name = '';
				for (var i = 0; i < this.games.length; i++) {
	        		if(this.games[i].id == game_id){
	        			game_name = this.games[i].name[this.$i18n.locale];
	        			for (var j = 0; j< this.games[i].regions.length; j++) {
	        				if(this.games[i].regions[j].id == region_id){
	        					region_name = this.games[i].regions[j].name;
	        				}
	        			}
	        		}
	        	}
	        	return game_name+' / '+region_name;
			},
			getPayment(paymen_id){
				for (var i = this.payments.length - 1; i >= 0; i--) {
					if(this.payments[i].id == paymen_id) return this.payments[i];
				}
				return null;
			},
			async getRecords(page){
				this.page = page;
				let params = {
					game_id:this.game_id,
					quick_selection:this.time,
					page:this.page,
					page_size:10,
					from: this.from
				}
				let response = await this.$api.get('/web/index/getChargeRecords',params);
				let charges = [];
				if(response.code == 0){
					this.lastPage = response.data.last_page;
					for(var i=0;i<response.data.data.length;i++){
						let pmt = this.getPayment(response.data.data[i].payment_id);
						response.data.data[i].payment = pmt;
						charges.push(response.data.data[i]);
					}
				}
				this.charges = charges;
			},
		},
		async created(){
			this.from = this.$route.query.from || '';
			console.log('history', this.from)
			let {games,payments} = await this.$getAppBaseData(this.from);
			this.games = games;
			this.payments = payments;
			this.game_id = this.games[0].id;
			this.getRecords(1);	
		},
		mounted(){

		}
	}
</script>
<style scoped>
	#history{
		padding: 20px;
	}
	.times a{
		display: inline-block;
		padding: 0 20px;
		height: 40px;
		border-radius: 3px;
		background-color: #f2f2f2;
		line-height: 40px;
		text-align: center;
		margin-right: 10px;
		font-size: 14px;
	}
	.times a.active{
		background-color: #c72729;
		color: #fff
	}
	.search-div{
		margin-top: 20px;
	}
	.search-div div{
		display: flex;
		height: 40px;
	}
	.search-div div label{
		text-align: right;
		width: 100px;
		padding-right: 10px;
	}

	select{
		margin-right: 10px;
		background-color: #dedede;
		width: 160px;
		border: none;
		height: 30px;
		outline: none;
	}


	table{
		width: 100%;
		margin-top: 30px;
	}
	table th,table td{
		height: 40px;
		border-bottom: 1px solid #f2f2f2;
		text-align: center;
		font-size: 14px;
	}
	table th{
		background-color: #f1f1f1;
	}
</style>